import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import { expertiseBg } from 'images/expertise';
import { ExperienceTextSection, StrokeSection, HistoryTextSection, CardsSection } from 'containers/expertise';

const Expertise: NextPage = () => {
  return (
    <>
      <Header title="Expertise" description="We build the Infrastructure your community needs" image={expertiseBg} />
      <ExperienceTextSection
        title="Trustable. Professional. Dedicated. Sustainable."
        description="Throughout our work experience, we were continually broadening our skills and our list of presented services. We have the necessary equipment, the right people in our team, and an overwhelming passion for our job. We deliver results by being adaptable and employing cutting-edge innovations."
      />
      <CardsSection />
      <HistoryTextSection
        textList={[
          {
            text: 'Utilities One is committed to maintaining high standards, exceeding customer expectations, and completing projects on time. We serve both civil and industrial infrastructure, using advanced technology and creative solutions to stay ahead in dynamic industries.',
          },
          {
            text: 'Our culture fosters a safe, supportive environment where people come first. We ensure employees and customers feel valued and secure.',
          },
          {
            text: 'With expertise in telecommunications, power, wireless, water, and technology sectors, we bring a people-focused approach to every project, prioritizing quality and reliability.',
          },
        ]}
      />
      <StrokeSection text="Engineering your future. Building a better tomorrow." />
    </>
  );
};

export default Expertise;
